/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { Experiment } from "./Experiment";
import {
  ExperimentFromJSON,
  ExperimentFromJSONTyped,
  ExperimentToJSON,
  ExperimentToJSONTyped,
} from "./Experiment";
import type { ProcessingState } from "./ProcessingState";
import {
  ProcessingStateFromJSON,
  ProcessingStateFromJSONTyped,
  ProcessingStateToJSON,
  ProcessingStateToJSONTyped,
} from "./ProcessingState";

/**
 *
 * @export
 * @interface ExperimentWithState
 */
export interface ExperimentWithState {
  /**
   *
   * @type {Experiment}
   * @memberof ExperimentWithState
   */
  experiment: Experiment;
  /**
   *
   * @type {ProcessingState}
   * @memberof ExperimentWithState
   */
  state: ProcessingState;
}

/**
 * Check if a given object implements the ExperimentWithState interface.
 */
export function instanceOfExperimentWithState(
  value: object,
): value is ExperimentWithState {
  if (!("experiment" in value) || value["experiment"] === undefined)
    return false;
  if (!("state" in value) || value["state"] === undefined) return false;
  return true;
}

export function ExperimentWithStateFromJSON(json: any): ExperimentWithState {
  return ExperimentWithStateFromJSONTyped(json, false);
}

export function ExperimentWithStateFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ExperimentWithState {
  if (json == null) {
    return json;
  }
  return {
    experiment: ExperimentFromJSON(json["experiment"]),
    state: ProcessingStateFromJSON(json["state"]),
  };
}

export function ExperimentWithStateToJSON(json: any): ExperimentWithState {
  return ExperimentWithStateToJSONTyped(json, false);
}

export function ExperimentWithStateToJSONTyped(
  value?: ExperimentWithState | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    experiment: ExperimentToJSON(value["experiment"]),
    state: ProcessingStateToJSON(value["state"]),
  };
}
